import { observer } from 'mobx-react-lite'
import PhoneCheckrModalImage from 'shared/assets/images/billing/PhoneCheckrModal.png'
import { Box, Typography } from 'shared/ui'
import { getCDNAssetURL } from 'shared/lib'

export const PhoneCheckModalContent = observer(() => {
  return (
    <>
      <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
        <Typography ariaLabel='phone_check_modal_title' variant='heading-lg'>
          PhoneCheckr
        </Typography>
        <Typography ariaLabel='phone_check_modal_description' variant='body-rg-regular'>
          $0.01 / lookup
        </Typography>
      </Box>
      <Typography
        ariaLabel='phone_check_first_modal_description'
        variant='body-rg-regular'
        color='var(--content-primary-tertiary)'
        tag='div'
        marginTop={'11px'}
        marginBottom={'32px'}
      >
        PhoneCheckr is a lookup tool that validates contacts’ phone numbers. It prevents sending
        messages to invalid numbers, thus losing credits and getting blocked by carriers. When
        activated, only contacts in this import will be checked.
      </Typography>

      <img src={getCDNAssetURL(PhoneCheckrModalImage)} alt='phone_check_modal_image' />
      <Typography
        ariaLabel='phone_check_modal_description'
        variant='text-input-label-small'
        color='var(--content-primary-tertiary)'
        tag='div'
        marginTop={'16px'}
      >
        PhoneCheckr will be billed to your account separately. It is not included in your
        subscription fee.
      </Typography>
    </>
  )
})
